export const TYPE = 'notification_list_refresh';

export interface NotificationListRefreshEventData {}